import React from 'react';
import PropTypes from 'prop-types';

import { VpButton } from '../..';

export const NavItems = ({ items }) => {
  const currentRoute = window.location.pathname;
  return items?.map((item) => (
    <VpButton
      key={item?.id}
      to={item?.url}
      variant="navitem"
      current={currentRoute.includes(item?.url) ? currentRoute : undefined}
    >
      {item.text}
    </VpButton>
  ));
};

NavItems.propTypes = {
  items: PropTypes.array
};

export default NavItems;



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavItems/NavItems.jsx